import React, { FC } from 'react'
import { RkoCardComponent } from './RkoCard'
import { RboCardComponent } from './RboCard'
import { Wrapper } from './styled'

export const BlockChoiceComponent: FC = () => (
	<Wrapper>
		<RboCardComponent />
		<RkoCardComponent />
	</Wrapper>
)
